import React, { FC, useState } from "react";

import { Col, Row } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Card from "react-bootstrap/Card";

import classNames from "classnames";

import styles from "./PendingNotification.module.scss";

export interface PendingNotificationProps {
  title: JSX.Element;
}

export const PendingNotification: FC<PendingNotificationProps> = ({ title }): JSX.Element => {
  const [visible, setVisible] = useState(true);

  const handleClose = () => {
    setVisible(false);
  };

  if (visible) {
    return (
      <div className={classNames(styles.notification)}>
        <Card className={classNames(styles.card, "notification")}>
          <Card.Body>
            <Row>
              <Col>
                <Card.Text>{title}</Card.Text>
              </Col>
              <Col xs="auto">
                <Button onClick={handleClose} className={styles["close-button"]}>
                  &times;
                </Button>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </div>
    );
  } else {
    return <></>;
  }
};
